import userActions from "./user";
import callActions from "./calls";
import leadActions from "./lead";
import taskAttributeActions from "./taskAttribute";

export default Object.assign(
  {},
  userActions,
  callActions,
  leadActions,
  taskAttributeActions
);
